import { QueryErrorResetBoundary } from '@tanstack/react-query'
import { ErrorBoundary } from 'react-error-boundary'
import { DataFetchingError } from '../data-fetching-error/DataFetchingError'

const fallbackRenderComponent = (
  // biome-ignore lint/suspicious/noExplicitAny: <explanation>
  resetErrorBoundary: (...args: any[]) => void
) => <DataFetchingError retry={resetErrorBoundary} />

export const QueryErrorBoundary = ({
  children
}: {
  children: React.ReactNode
}) => {
  return (
    <QueryErrorResetBoundary>
      {({ reset }) => (
        <ErrorBoundary
          onReset={reset}
          fallbackRender={({ resetErrorBoundary }) =>
            fallbackRenderComponent(resetErrorBoundary)
          }
        >
          {children}
        </ErrorBoundary>
      )}
    </QueryErrorResetBoundary>
  )
}
